// extracted by mini-css-extract-plugin
export default {"header":"ListViewHeaderStyle_header__GEgSA","label":"ListViewHeaderStyle_label__FY5iE"};